export const CrimeType = {
  various_crime: "Various Crime",
  corruption_crime: "Corruption Crime",
  economic_crime: "Economic Crime",
  child_and_women: "Child and Women",
};
export const CrimeTypeForInvestigationType = {
  various: "Various",
  corruption: "Corruption",
  economic: "Economic",
  child_and_women: "Child and Women",
};
export const IncidentDecisionType = {
  pending: "Pending",
  constitutes_offence: "Constitutes Crime Offence",
  does_not_constitute: "Does Not Constitute Crime Offence",
  not_under_authority: "Not Under the Authority of the Office",
};
export const ProsecutorDecisionType = {
  pending: "Pending",
  further_investigation: "Further Investigation",
  closure_of_investigation: "Closure of Investigation",
  decision_not_to_charge: "Decision Not to Charge",
  Frame_charge: "Frame Charge",
  petty_offence: "Petty Offence",
  out_of_jurisdiction: "Out of Jurisdiction",
  suspend: "Case Suspension",
};
export const InvestigationFileStatus = {
  forward_to_coordinator: "Forward to Coordinator",
  assigned_to_prosecutor: "Assigned to Prosecutor",
  assigned_to_clerk: "Assigned to Clerk",
  forward_to_registrar: "Forward to Registrar",
  on_litigation: "On Litigation",
  final_verdict_given: "Final Verdict Given",
  on_appeal: "On Appeal",
  pending: "Pending",
  terminated: "Terminated",
  closed_by_prosecutor: "Closed by Prosecutor",
  further_investigation_requested: "Further Investigation Requested",
  case_suspended: "Case Suspended",
  out_of_jurisdiction: "Out of Jurisdiction",
  case_terminated_by_court: "Case Terminated By Court",
  case_dismissed: "Case Dismissed",
  responddback_to_police: "Respond Back to Police",
  respondabck_corrected_by_police: "Respond Back Corrected by Police",
};
export const ProsecutorDecisionStatus = {
  pending: "Pending",
  approved: "Approved",
  revised: "Revised",
};
export const OpeniningCaseFileStatus = {
  Pending: "Pending",
  forwarded_to_registrar: "Forwarded to Registrar",
  forwarded_to_coordinator: "Forwarded to Coordinator",
  assigned_to_prosecutor: "Assigned to Prosecutor",
};
export const FurtherInvestigationDecision = {
  revised: "Revised",
  forward_to_coordinator: "Forward to Coordinator",
  back_coordinator: " Back Coordinator",
  forward_to_police: "Assigned to Police",
  assigned_to_clerk: "Assigned to Clerk",
  forward_to_registrar: "Forward to Registrar",
  back_to_registrar: "Back to Registrar",
  back_to_prosecutor: "Back to Prosector",
  pending: "Pending",
  revice: "Revise",
  approve: "Approve",
  rejected: "Rejected",
};
export const Roles = {
  prosecutionDirector: "ProsecutionCaseDirector",
  // economicDirector: "CorruptionEconomicProsecutionCaseDirector",
  // coordinator: "Prosecutor",
  coordinator: "ProsecutionCaseCoordinator",
  variousCoordinator: "NewVariousCaseCoordinator",
  economicCoordinator: "NewEconomicCaseCoordinator",
  corruptionCoordinator: "NewCorruptionCaseCoordinator",

  variousAppealCoordinator: "VariousAppealCoordinator",
  economicAppealCoordinator: "EconomicAppealCoordinator",
  corruptionAppealCoordinator: "CorruptionAppealCoordinator",

  prosecutor: "ProsecutionCaseProsecutor", //InspectionProsecutor
  economicProsecutor: "EconomicProsecutor",

  clerk: "ProsecutionCaseClerk",
  variousClerk: "VariousProsecutionCaseClerk",
  economicClerk: "EconomicProsecutionCaseClerk",
  corruptionClerk: "CorruptionProsecutionCaseClerk",

  registrar: "Registrar",
  // police: " ProsecutionCasePolice",
  // regionalOfficeOfCouncilHead: "RegionalOfficeOfCouncilHead",
  screeningTeamCoordinator: "ProsecutionCaseScreeningTeamCoordinator",
  // externalPolice: "Police",
  // externalPoliceCoordinator: "PoliceCoordinator",
  generalAttorney: "GeneralAttorney",
  deputy: "ProsecutionCaseDeputy",

  member: "Member",

  assetProsecutor: "AssetRecoveryProsecutor",
  assetCoordinator: "AssetRecoveryCoordinator",
  director: "ProsecutionCaseDirector",

  economicDirector: "economicprosecutioncasedirector",
  corruptionDirector: "CorruptionProsecutionCaseDirector",
  variousDirector: "variousprosecutioncasedirector",

  newVariousProsecutor: "NewVariousProsecutionCaseProsecutor",
  newCorruptionProsecutor: "NewCorruptionProsecutionCaseProsecutor",
  newEconomicProsecutor: "NewEconomicProsecutionCaseProsecutor",

  appealProsecutor: "AppealProsecutor",
  appealVariousProsecutor: "AppealVariousProsecutionCaseProsecutor",
  appealEconomicProsecutor: "AppealEconomicProsecutionCaseProsecutor",
  appealCorruptionProsecutor: "AppealCorruptionProsecutionCaseProsecutor",
  appealChildAndWomenCaseProsecutor: "AppealChildAndWomenCaseProsecutor",

  childWomenCoordinator: "newchildandwomencasecoordinator",
  childWomenProsecutor: "ChildAndWomenCaseProsecutor",
  childWomenClerk: "childandwomenprosecutioncaseclerk",

  variousRegistrar: "CaseVariousRegistrar",
  economicRegistrar: "CaseCorruptionRegistrar",
  corruptionRegistrar: "CaseEconomicRegistrar",

  variousDeputy: "VariousCaseProsecutionCaseDeputy",
  economicDeputy: "EconCourCaseProsecutionCaseDeputy",

  childAppealCoordinator: "ChildAndWomenAppealCoordinator",

  zonalEconomicCoruptionRegistrsrar: "zonalcorecoregistrsrar",
  zonalVariousChildWomenRegistrar: "Zonalvarchildwomenregistrar",

  zonalEconomicCoruptionClerk: "zonalcorecorclerk",
  zonalVariousChildWomenClerk: "Zonalvarchildwomenclerk",

};
export const InvestigationStatus = {
  Ongoing: "Ongoing",
  Completed: "Completed",
};
export const InvestigationStatus2 = {
  pending: "Pending",
  terminated: "Terminated",
  forwarded: "Forwarded",
  forwarded_to_cordinator: "Forwarded to Cordinator",
  forwarded_to_clerk: "Forwarded to clerk",
  forwared_to_police: "Forwarded to Police",
  sent_to_police: "Sent to Police",
  asigned_to_clerk: "Assigned to Clerk",
  back_to_cordinator: "Back to Cordinator",
};

export const IncidentStatus = {
  pending: "Pending",
  terminated: "Terminated",
  forwarded: "Forwarded",
  "forwarded to cordinator": "Forwarded to Cordinator",
  "forwarded to director": "Forwarded Director",
  "forwarded to screeingteam": "Forwarded to Screaning Team",
  forwared_to_police_cordinator: "Forwarded to Police Cordinator",
  forwarded_to_cordinator_cor: "Forwarded to Cordinator",
  "forwarded to registrar": "Forwarded to Registrar",
  sent_to_police: "Sent to Police",
  "forwarded to cordinatorforscreening": "Forwarded to Cordinator Screeing",
  "forwarded to cordinatorforscreeningadditional": "Forwarded to Cordinator",
};
export const CaseStatus = {
  Pending: "Pending",
  Respond_Back_cordinator: "Respond Back Cordinator",
  investigation_recorded: "Investigation Recorded",
  Respond_Back_prosecutor: "Respond Back Prosecutor",
  Approved: "Approved",
  forwarded_to_director: "Forwarded to Director",
  forwarded_to_coordinator: "Forwarded to Coordinator",
  forwarded_to_registrar: "Forwarded to Registrar",
  sent_to_court: "Sent To Court",
  on_panel: "On Panel",
  case_on_updated: "Case On Updated",
  case_terminated_by_court: "Case Terminated By Court",
  out_of_jurisdiction: " Out of Jurisdiction",
};
export const Gender = {
  Male: "Male",
  Female: "Female",
};
export const ExternalUserRole = {
  police: "Police",
  police_coordinator: "Police Coordinator",
};
export const ReferenceType = {
  individual_incident: "Incident on Individual",
  public_incident: "Incident on Public",
};

export interface CrimeReferenceReceptionMethod {
  uu_id: number;
  reception_method: string;
  description: string;
}

export const ScreeningOutcomeType = {
  approved: "Approved",
  rejected: "Rejected",
  further_investigation: "Further Investigation",
  forwarded_to_director: "Forwarded To Director",
};
export const CrimeLevel = {
  Heavy: "Heavy",
  Medium: "Medium",
  Light: "Light",
};
export const DefendantCaseStatus = {
  Pending: "Pending",
  Respond_Back_cordinator: "Respond Back Cordinator",
  investigation_recorded: "Investigation Recorded",
  Respond_Back_prosecutor: "Respond Back Prosecutor",
  Approved: "Approved",
  forwarded_to_director: "Forwarded to Director",
  forwarded_to_coordinator: "Forwarded to Coordinator",
  forwarded_to_registrar: "Forwarded to Registrar",
  sent_to_court: "Sent To Court",
};
export const DailyReportStatus = {
  pending: "Pending",
  in_progress: "In Progress",
  scheduled: "Scheduled",
  decision_provided: "Decision Provided",
};
export interface Prosecutor {
  uu_id: number;
  full_name: string;
  work_level: string;
  working_id: string;
  email: string;
  phone_number: string;
  created_at: Date;
}
export interface Police {
  uu_id: number;
  full_name: string;
  work_level: string;
  badge_number: string;
  department: string;
  email: string;
  phone_number: string;
  created_at: Date;
}
export interface ScreeningTeamMember {
  id?: number;
  prosecutor_name: string;
  prosecutor_user_id: string;
  team_leader: boolean;
  crime_reference: CrimeReference | number;
}
export interface CrimeReference {
  is_efling: boolean;
  uu_id: number;
  crime_narrative_files?: string | File | null;
  crime_reference_number: string;
  date_received?: Date | null;
  crime_type?: keyof typeof CrimeType | null;
  reception_method?: CrimeReferenceReceptionMethod | null;
  reception_method_id?: number | null;
  category?: string | null;
  receiving_prosecutor?: string; // Prosecutor | number | null;
  receiving_prosecutor_id?: Prosecutor | null;
  receiving_police?: Police | number | null;
  receiving_police_id?: Police | null;
  description?: string | null;
  status: keyof typeof IncidentStatus;

  crime_incidence_time?: string | null;
  crime_incident_narrative: string | null;
  victim_status: string | null;
  crime_category: string | null;
  evidence_written: string | null;
  tools_used: string | null;

  crime_incidence_region: string | null;
  crime_incidence_zone: string | null;
  crime_incidence_city: string | null;
  crime_incidence_woreda: string | null;
  crime_incidence_kebele: string | null;
  crime_incidence_site: string | null;

  screening_outcome: keyof typeof ScreeningOutcomeType | null;
  follow_up_action: string | null;
  decision_type: keyof typeof IncidentDecisionType | null;
  decision_date: Date | null;

  reporters?: Reporter[] | null;
  screening_team?: number[] | [];
  screening_members?: ScreeningTeamMember[] | [];
  screening_team_details?: Prosecutor[];
  victims?: Victim[] | null;
  suspects?: Suspect[] | null;
  witnesses?: Witness[] | null;
  Incident_Registration_number?: string | null;
  registration_number?: string | null;
  reference_type?: keyof typeof ReferenceType | null;
  asset_reference?: string | null;
  decision_details?: string | null;
  team_leader?: Prosecutor | null;
  team_leader_id?: number | null;
  crime_naretive_file?: string | File | null;
  screening_team_findings?: ScreeningFindings[];
  is_letter: boolean;

  crime_naretive_file_details?: {
    dms_uuid: string;
    file_name: string;
    url: string;
  };

  investigations?: Investigation[] | null;

  report_application_number?: string;
  incident_application_number?: string;

  mesage_for_screeningteam?: string | null;

  year?: string | null;
  incident_timestamp?: string | null;
  created_at?: string | Date | null;
  admin_unit_id?: string | number | null;
}
// interface CrimeReferenceEvidence {
//   uu_id: number;
//   evidence_type: string;
//   description: string;
//   date_collected: Date;
//   collected_by: string;
//   document: string;
//   crime_reference: CrimeReference;
// }

export interface Suspect {
  uu_id: number;
  CR_number?: string | null;
  first_name?: string;
  middle_name?: string;
  last_name?: string;
  gender?: keyof typeof Gender | null;
  age?: number | null;
  education_level?: string | null;

  job_position?: string | null;
  ethnicity?: string | null;
  nationality?: string | null;
  religion?: string | null;
  date_of_birth: Date;
  phone_number?: string | null;
  email?: string | null;
  identity_card_number?: string | null;
  region?: string | null;
  zone?: string | null;
  woreda?: string | null;
  kebele?: string | null;
  house_number?: string | null;
  city?: string | null;

  criminal_record?: string | null;
  statement?: string | null;
  is_in_custody?: Boolean | null;
  investigation?: Investigation | number | null;

  picture_file?: string | File | null;
  picture_dms_uuid?: number | null;

  crimereference?: CrimeReference | number | null;
  Incident_Registration_number?: string | null;

  is_converted_to_witness?: boolean;

  documents?: DocumentSchema[];

  is_defendant?: boolean;
  closed_by_42?: boolean;
  reason_for_closure?: string | null;
}

export interface Witness {
  uu_id: number;
  witness_info_detail?: Witness;
  preliminary?: PreliminaryInquiry;
  CR_number?: string | null;
  investigation?: Investigation | number | null;
  first_name?: string;
  middle_name?: string;
  last_name?: string;
  gender?: keyof typeof Gender | null;
  age?: number | null;
  education_level?: string | null;

  job_position?: string | null;
  ethnicity?: string | null;
  nationality?: string | null;
  religion?: string | null;
  date_of_birth: Date;
  phone_number?: string | null;
  email?: string | null;
  identity_card_number?: string | null;
  region?: string | null;
  zone?: string | null;
  woreda?: string | null;
  kebele?: string | null;
  house_number?: string | null;
  city?: string | null;

  testimony?: string | null;
  statement?: string | null;

  picture_file?: string | File | null;
  picture_dms_uuid?: number | null;

  crimereference?: CrimeReference | number | null;
  Incident_Registration_number?: string | null;

  documents?: DocumentSchema[];
}

export interface Victim {
  uu_id: number;
  CR_number?: string | null;
  investigation?: Investigation | number | null;
  first_name?: string;
  middle_name?: string;
  last_name?: string;
  gender?: keyof typeof Gender | null;
  age?: number | null;
  education_level?: string | null;

  job_position?: string | null;
  ethnicity?: string | null;
  nationality?: string | null;
  religion?: string | null;
  date_of_birth: Date;
  phone_number?: string | null;
  email?: string | null;
  identity_card_number?: string | null;
  region?: string | null;
  zone?: string | null;
  woreda?: string | null;
  kebele?: string | null;
  house_number?: string | null;
  city?: string | null;

  injury_details?: string | null;
  statement?: string | null;

  picture_file?: string | File | null;
  picture_dms_uuid?: number | null;

  documents?: DocumentSchema[];

  crimereference?: CrimeReference | number | null;
  Incident_Registration_number?: string | null;
}

export interface Governmental {
  uu_id: number;
  governmental_type: string;
  office_name: string;
  department: string;
  address: string;
  CR_number?: string | null;
  investigation?: Investigation | number | null;
  crimereference?: CrimeReference | number | null;
}

export interface NonGovernmental {
  uu_id: number;
  organization_name: string;
  registration_number: string;
  non_governmental_type: string;
  address: string;
  CR_number?: string | null;
  investigation?: Investigation | number | null;
  crimereference?: CrimeReference | number | null;
}
interface Document {
  document_dms_uuid: string;
  file: string;
  id: number;
  uploaded_at: Date;
}
export interface Evidence {
  uu_id: number;
  CR_number?: string | null;
  evidence_type: string;
  description?: string;
  date_collected?: Date;
  collected_by: string;
  investigation?: Investigation | number | null;
  crimereference?: CrimeReference | number | null;
  Incident_Registration_number?: number | null;
  file_attachments?: string[] | File[] | [];
  attachment_details: Document[];
  documents?: DocumentSchema[];
}
export interface Exhibit {
  uu_id: number;
  exhibit_attachment_files: File[];
  attachments?: {
    document_dms_uuid: string;
    file: string;
    id: number;
    uploaded_at: Date;
  }[];
  prosecution_files?: File;
  court_files?: File;
  crimereference: CrimeReference | number;
  Incident_Registration_number?: string;
  CR_number?: string;
  tool_type?: string;
  description?: string;
  date_collected?: Date;
  collected_by?: string;
  unique_identification_code?: string;
  reference_number?: string;
  serial_number?: string;
  location_region?: string;
  location_zone?: string;
  location_woreda?: string;
  location_housenumber?: string;
  location_site?: string;
  person_with_whom?: string;
  owner?: string;
  quantity_written?: string;
  date_of_exhibit?: Date;
  exibit_condition?: string;
  person_protect_fullname?: string;
  person_protect_region?: string;
  person_protect_zone?: string;
  person_protect_woreda?: string;
  person_protect_housenumber?: string;
  person_protect_phonenumber?: string;
  person_protect_site?: string;
  government_protect_name?: string;
  government_protect_region?: string;
  government_protect_zone?: string;
  government_protect_woreda?: string;
  government_protect_housenumber?: string;
  government_protect_phonenumber?: string;
  government_protect_site?: string;
  exhibit_condition_when_submitted?: ExhibitCondition | string;
  prosecution_decision_type?: string;
  prosecution_decision_description?: string;
  prosecution_decision_file?: File | null;
  prosecutor_decision_date?: Date;
  court_decision_type?: string;
  court_decision_description?: string;
  court_decision_file?: File | null;
  court_decision_date?: Date;
  investigation?: Investigation | number;

  is_sample_collected?: boolean;
  sample_collected_by?: string;
  sample_collection_date?: Date;
  sample_amount?: string;
  sample_location?: string;
  analysis_result?: string;
  is_sample_returned?: boolean;
  sample_return_date?: Date;

  is_exibit_retuned?: boolean;
  exhibit_return_date?: Date;
  exhibit_returned_to?: string;
  exhibit_return_condition?: string;
  is_exbit_sold?: boolean;
  exhibit_sale_date?: Date;
  exhibit_sale_amount?: string;

  documents?: DocumentSchema[];
}
export interface Reporter {
  uu_id: number;
  first_name: string;
  middle_name: string;
  last_name: string;
  gender?: keyof typeof Gender | null;
  age?: number | null;
  education_level: string;
  job_position: string;
  ethnicity: string;
  nationality: string;
  religion: string;
  date_of_birth?: Date | null;
  phone_number: string;
  email: string;
  identity_card_number: string;
  region: string;
  zone: string;
  woreda: string;
  kebele: string;
  house_number: string;
  city: string;
  report_details: string;
  crimereference?: CrimeReference | null;

  picture_file?: string | File | null;
  picture_dms_uuid?: number | null;
  documents?: DocumentSchema[];
}
export interface DocumentSchema {
  uu_id: string;
  document_type: string;
  document_uuid: string;
  document_path: string;
  created_at: string;
  updated_at: string;
  reporter: string;
}
export interface CrimeCategory {
  uu_id: number;
  crime_category_name: string;
  category_description: string;
}
export interface CrimeSubCategory {
  uu_id: number;
  crime_subcategory_name: string;
  subcategory_description: string;
  category_id: CrimeCategory;
}
export interface Investigation {
  uu_id: number;
  documents?: DocumentSchema[];
  assigned_prosecutor?: string;
  assigned_police?: string;
  crime_reference?: CrimeReference | null;
  crime_reference_id?: CrimeReference | null;
  CR_number: string;
  crime_category?: CrimeSubCategory | null;
  crime_category_id?: CrimeSubCategory | number | null;
  investigation_status?: keyof typeof InvestigationStatus | null;
  status?: keyof typeof InvestigationStatus2 | null;
  prosecutor?: Prosecutor | null;
  prosecutor_id?: Prosecutor | null;
  police?: Police | null;
  police_id?: Police | null;
  assigned_team: "";
  start_date?: Date | null;
  end_date?: Date | null;
  description: string;
  investigation_result_naration: string;
  director_comments?: DirectorComment[] | [];
  coordinator_comments?: DirectorComment[] | [];

  Incident_Registration_number: string;
  asset_reference: "";
  crime_naretive_file?: string | File | null;
  investigation_result_naration_file?: string | File | null;

  ec_reference_result_file_upload?: string | File | null;
  ec_reference_result_file_details?: {
    dms_uuid: number;
    file_name: string;
    url: string;
  };
  ec_reference_result_file_dmsuuid?: string;
  ec_police_station_name?: string;
  ec_police_station_id?: string;
  sent_date_to_police?: Date;
  sent_back_to_cordinator?: Date;
  reciving_date?: Date;

  report_application_number?: string;
  incident_application_number?: string;
}
export interface HierarchyLevel {
  uu_id: string;
  name: string;
  display_name: string;
}

export interface AdminUnit {
  uu_id: string;
  hierarchy_level: HierarchyLevel;
  unit_name: string;
  structure_level: string;
  is_regiometropolitan: boolean;
  is_branch: boolean;
  description: string;
  parent_unit: string;
  branch_unit: string | null;
}

export interface OrgUnit {
  uu_id: string;
  hierarchy_level: HierarchyLevel;
  unit_name: string;
  structure_level: string;
  description: string;
  is_vacant: boolean;
  is_open: boolean;
  parent_unit: string;
}

export interface ChildOrgUnits {
  message: string;
  tree: {
    uu_id: string;
    unit_name: string;
    description: string;
    structure_level: string;
    hierarchy_level: string;
    parent: string;
    children: any[]; // You can define a recursive type if needed
  };
}

export interface ChildAdminUnit {
  unit_name: string;
  description: string;
  uu_id: string;
  hierarchy_level: string;
  structure_level: string;
  is_regiometropolitan: boolean;
  is_branch: boolean;
}

export interface ChildAdminUnits {
  message: string;
  units: ChildAdminUnit[];
}

export interface Department {
  uu_id: string;
  unit_name: string;
}

export interface Departments {
  message: string;
  tree: Department[];
}

export interface HierarchyCurrent {
  uu_id: string;
  hierarchy_level: HierarchyLevel;
  unit_name: string;
  structure_level: string;
  description: string;
  is_vacant: boolean;
  is_open: boolean;
  parent_unit: string;
}

export interface Hierarchy {
  current: HierarchyCurrent;
  parent_chain: any[]; // Define type if you have parent chain structure
}

export interface StructureData {
  admin_unit: AdminUnit;
  org_unit: OrgUnit;
  child_org_units: ChildOrgUnits;
  child_admin_units: ChildAdminUnits;
  departments: Departments;
  hierarchy: Hierarchy;
}
export interface LoginAccount {
  [x: string]: any;
  id?: string;
  access: string;
  access_token: string;
  refresh: string;
  refresh_token: string;
  type: "Main" | "Police";
  user_id: number;
  username: string;
  permissions: string[];
  role?: string;
  roles: string[];
  user_groups?: string[];
  police_station_name: string | null;
  employee_id: number;
  admin_unit: number;
  org_unit: number;
  user_type: string;
  is_superuser: boolean;
  full_name: string;
  email?: string;
  user?: ExternalPolice | null;
  structure?: StructureData;
  is_police?: boolean;
}
export interface DirectorComment {
  uu_id: number;
  comment: string;
  commented_at?: Date;
  investigation?: Investigation | number | null;
}
export interface CoordinatorComment {
  uu_id: number;
  comment: string;
  commented_at?: Date;
  investigation?: Investigation | number | null;
}
export interface CoordinatorCommentOnInvestigationFile {
  id?: number;
  comment_text: string;
  created_by?: string;
  created_at?: Date;
  investigation_file?: number | null;
}
export interface PreliminaryInquiry {
  uu_id: number;
  prosecutor_registration_number: string;
  police_registration_number: string;
  reason_for_preliminary_inquiry: string;
  court_name: string;
  body_receiving_the_copy: string;
  inquiry_date?: Date;
  findings: string;
  investigation?: Investigation | number | null;
  applying_prosecutor?: string;
  witness_list?: Witness[] | [];
}
export interface PreliminaryInquiryWitness {
  uu_id: number;
  witness_info: number;
  preliminary_inquiry: number;
  witness_info_detail?: PreliminaryInquiry;
  their_statement?: string;
  createdAt?: Date;
}
export interface Schedule {
  id: number;
  police_station_name: "";
  starting_date_time?: Date;
  end_date_time?: Date;
  org_phone_number?: string;
  police_station_id?: string;
  adminunit_id?: string;
}
export const InvestigationFileBy = {
  oromia_case: "Regional Case",
  federal_case: "Federal Case",
};
export interface InvestigationFile {
  uu_id: number;
  id?: number;
  documents: DocumentSchema[];
  schedule_file_receiving_date?: Date;
  police_station_name: any;
  crime_reference_number: string;
  investigation_file?: File | null;
  incident_registration_number: string;
  prosecutor_registration_number: string;
  assign_clerk: string;
  assign_prosecutor: string;
  assign_prosecutor_id?: string;
  receiving_date?: Date;
  status: keyof typeof InvestigationFileStatus | null;
  previous_status?: keyof typeof InvestigationFileStatus | null;
  prosecutor_decision_type: keyof typeof ProsecutorDecisionType | null;
  prosecutor_decision_status: keyof typeof ProsecutorDecisionStatus | null;
  prosecutor_feedbacks?: ProsecutorDecisionFeedback[];

  police_station_id: any;
  is_efiling?: boolean;
  is_efiling_ec?: boolean;
  investigation_file_upload?: File | null | undefined;
  investigation_file_details?: { file_name: string; url: string };
  investigationfileby?: keyof typeof InvestigationFileBy | null;
  investigation_result_naration_file_details?: DocumentInfo;

  is_peety_offence?: boolean;
  petty_offence_decison?: string;
  petty_offence_decision_reason?: string;
  petty_offence_decision_date?: Date;
  petty_offence_decision_file?: File | null;
  petty_offence_decision_file_info?: {
    file_name: string;
    file_url: string;
  };

  decision_file?: File | null;
  decision_reason?: string;
  decision_date?: Date;
  decision_file_info?: {
    file_name: string;
    file_url: string;
  };
  // History of uploaded files (prosecutor_decision, petty_offence_decision, …).
  upload_history?: {
    id?: string;
    file?: string;
    file_type?: string;
    uploaded_by?: string;
    created_at?: string;
  }[];

  crime_type?: keyof typeof CrimeTypeForInvestigationType | null;
  org_id?: string | number;
  admin_unit_id?: string | number;

  is_case_suspended?: boolean;
  createdAt?: string | Date;
  case_suspension_date?: Date;
  case_suspension_reason?: string;
  case_resume_date?: Date;
  case_resume_reason?: string;

  // Re-initiation of a closed case (backend field name kept as-is).
  is_re_intiated?: boolean;
  re_initiation_date?: Date | string | null;
  re_initiation_reason?: string | null;

  out_of_jursdicition_source?: string;
  is_case_out_of_jurisdiction?: boolean;

  report_application_number?: string;
  incident_application_number?: string;

  cordinator_comments?: CoordinatorCommentOnInvestigationFile[] | [];
  private_prosecutions?: PrivateProsecution[] | [];
  further_investigation_requests?: FurtherInvestigation[] | [];

  prosecutor_assignment_date?: Date;
}
export interface ProsecutorDecisionFeedback {
  uu_id: number;
  feedback_text: string;
  investigation_file: InvestigationFile | number;
  created_at?: Date;
}
export interface FurtherInvestigation {
  is_efiling?: boolean;
  uu_id: number;
  id: number;
  suspects_ids: Suspect[] | number[];
  suspects?: Suspect[] | [];
  crime_registration_number: string;
  prosecutor_registration_number: string;
  incident_registration_number: string;
  suspect_condition: string;
  file_submitted_by: string;
  reason_for_request: string;
  requesting_body: string;
  date_requested?: Date;
  coordinator_feedback?: string;
  date_approved?: Date;
  letter_number_sent?: string;
  date_sent_to_police?: Date;
  letter_number_received?: string;
  date_received_from_police?: Date;
  number_of_days_given?: number | null;
  decision?: keyof typeof FurtherInvestigationDecision;
  decision_reason?: string;
  by_letter?: Boolean;
  investigation_file?: InvestigationFile | number | null;
  feedbacks?: FurtherInvestigationFeedback[] | [];
  additional_investigation_file?: File | undefined; // request file
  additional_investigation_result_file?: File | undefined; // police result file
  police_station_id?: string | null;
  police_station_name?: string | null;
  documents?: DocumentSchema[];
}
export interface ScreeningFindings {
  uu_id: number;
  file_uploads: string | File | null;
  description?: string;
  crime_reference: CrimeReference | number | null;
  uploaded_at?: Date;
  documents?: DocumentSchema[];
}
export const CaseStatusFilter = {
  on_charge_draft: "On Charge Draft",
  on_court_hearing: "On Court Hearing",
  final_verdict_given: "Final Verdict Given",
  appealed: "On Appeal",
};

// ---- Court Application / Remand / Execution (tied to a CaseCreation) ----

export const CourtApplicationStatus = {
  pending: "Pending",
  forwarded_to_coordinator: "Forwarded to Coordinator",
  forwarded_to_registrar: "Forwarded to Registrar",
  sent_to_court: "Sent to Court",
  returned_to_registrar: "Returned to Registrar",
  returned_to_coordinator: "Returned to Coordinator",
  returned_to_prosecutor: "Returned to Prosecutor",
  completed: "Completed",
};

export interface CourtApplicationFeedback {
  id?: string;
  court_application?: string;
  role?: string;
  feedback_text?: string;
  created_at?: string;
  created_by?: string;
}

export interface CourtApplicationRespondBack {
  id?: string;
  court_application?: string;
  role?: string;
  comment?: string;
  status?: string;
  created_at?: string;
  created_by?: string;
}

export interface CourtApplication {
  id?: string;
  case?: string;
  title?: string;
  application_summary?: string;
  status?: keyof typeof CourtApplicationStatus;
  application_file?: File | null;
  court_report_file?: File | null;
  // Court info filled by the registrar when sending to court.
  court_name?: string | null;
  court_type?: string | null;
  court_level?: string | null;
  registrar_number?: string | null;
  // Court report filled by the registrar when the case returns from court.
  court_report_summary?: string | null;
  court_decision?: string | null;
  court_decision_date?: string | null;
  admin_unit_id?: string | null;
  assigned_prosecutor?: string | null;
  assigned_prosecutor_id?: string | null;
  documents?: DocumentSchema[];
  feedbacks?: CourtApplicationFeedback[];
  respond_backs?: CourtApplicationRespondBack[];
  created_at?: string;
  updated_at?: string;
}

// ----- Director Feedback (directives / comments attached to any record) -------
export const FEEDBACK_MODEL = {
  case: "crime_case_management.casecreation",
  prosecutorAppeal: "appeal.appealrequest",
  defendantAppeal: "appeal.defendantappealrequest",
  investigationFile: "prosecutor_police.receivinginvestigationfile",
  crimeReference: "crime_reference_management.crimereference",
  bail: "bail_right.bailright",
  remand: "crime_case_management.remand",
  execution: "crime_case_management.execution",
  courtApplication: "crime_case_management.courtapplication",
  appealApplication: "appeal.appealapplication",
  assetReferral: "asset_recovery.assetreferral",
  witnessProtection: "witness_protection.witnessprotectionrequest",
} as const;

export type DirectorFeedbackType = "comment" | "feedback" | "directive";

export interface DirectorFeedback {
  id?: string;
  model?: string;
  object_id?: string | number;
  parent?: string | null;
  feedback_type?: DirectorFeedbackType;
  is_directive?: boolean;
  requires_action?: boolean;
  status?: string;
  message?: string;
  author_name?: string;
  author_id?: string;
  role?: string;
  admin_unit_id?: string | null;
  created_at?: string;
  content_type_app?: string;
  content_type_model?: string;
  replies?: DirectorFeedback[];
  documents?: DocumentSchema[];
}

// ----- Appeal Application (prosecutor asks to send appeal/cassation to court) -
export const AppealApplicationStatus = {
  pending: "Pending",
  forwarded_to_coordinator: "Forwarded to Coordinator",
  returned_to_prosecutor: "Returned to Prosecutor",
  forwarded_to_registrar: "Forwarded to Registrar",
  sent_to_court: "Sent to Court",
  returned_to_coordinator: "Returned to Coordinator",
  completed: "Completed",
};

export interface AppealApplicationFeedback {
  id?: string;
  application?: string;
  role?: string;
  feedback_text?: string;
  created_at?: string;
  created_by?: string;
}

export interface AppealApplicationRespondBack {
  id?: string;
  application?: string;
  role?: string;
  comment?: string;
  status?: string;
  created_at?: string;
  created_by?: string;
}

export interface AppealApplication {
  id?: string;
  appeal_request?: string | null;
  defendant_appeal_request?: string | null;
  title?: string;
  application_summary?: string;
  status?: keyof typeof AppealApplicationStatus;
  application_file?: File | null;
  court_report_file?: File | null;
  // Court info filled by the registrar when sending to court.
  court_name?: string | null;
  court_type?: string | null;
  court_level?: string | null;
  registrar_number?: string | null;
  // Court report filled by the registrar when it returns from court.
  court_decision?: string | null;
  court_decision_date?: string | null;
  admin_unit_id?: string | null;
  documents?: DocumentSchema[];
  feedbacks?: AppealApplicationFeedback[];
  respond_backs?: AppealApplicationRespondBack[];
  created_at?: string;
  updated_at?: string;
}

export const RemandStatus = {
  pending: "Pending",
  forwarded_to_coordinator: "Forwarded to Coordinator",
  assigned_to_prosecutor: "Assigned to Prosecutor",
  on_hearing: "On Hearing",
  completed: "Completed",
};

export interface Remand {
  id?: string;
  case?: string;
  court_source?: string;
  registrar_name?: string;
  remand_reason?: string;
  status?: keyof typeof RemandStatus;
  remand_file?: File | null;
  admin_unit_id?: string | null;
  assigned_prosecutor?: string | null;
  assigned_prosecutor_id?: string | null;
  documents?: DocumentSchema[];
  created_at?: string;
  updated_at?: string;
}

export const ExecutionType = {
  imprisonment: "Imprisonment",
  fine: "Fine",
  compensation: "Compensation",
  asset: "Asset",
  other: "Other",
};

export interface Execution {
  id?: string;
  case?: string;
  execution_type?: keyof typeof ExecutionType | string;
  court_decision?: string;
  court_decision_amount?: string | number | null;
  court_decision_file?: File | null;
  execution_file?: File | null;
  final_verdict?: string | null;
  count_defendant?: string | null;
  defendant?: string | null;
  admin_unit_id?: string | null;
  assigned_prosecutor_id?: string | null;
  documents?: DocumentSchema[];
  created_at?: string;
  updated_at?: string;
}
export const CaseRelationType = {
  merged: "Merged",
  split: "Split",
  original: "Original",
};
export interface CaseCreation {
  id: number;
  documents?: DocumentSchema[];
  prosecutor_registration_number: string;
  date_sent_to_prosecutor?: Date;
  estimated_day_to_finish?: Date;
  status: keyof typeof CaseStatus | null;
  old_status?: keyof typeof CaseStatus | null;
  crime_type?: keyof typeof CrimeTypeForInvestigationType | null;

  investigation_files?: InvestigationFile[] | number[] | string[];
  case_defendant_links?: CaseDefendantLink[];
  opening_case_files?: OpeniningCaseFile[] | [];
  comments?: CommentOnCaseDraft[] | [];
  incident_registration_no: string;
  crime_refernce_number: string;

  termination_status?: boolean;
  termination_reason?: string;
  termination_date?: Date;

  final_court_decision_info?: DocumentInfo;

  defendants?: Suspect[];
  status_filter?: keyof typeof CaseStatusFilter | null;
  relation_type: keyof typeof CaseRelationType | null;
  defendant_number?: number;
  upload_charge_draft?: File | null;
  upload_panel_decision?: File | null;
  upload_panel_decision_info?: {
    file_name: string;
    file_url: string;
  };
  reassign_prosecutor?: string;
  reassign_prosecutor_userid?: string;
  counts?: CountDefendantsList[] | [];
  witnesses?: WitnessDefendants[] | [];
  exhibits?: Exhibit[] | [];
  PreJudgementEntry?: PreJudgement[] | [];
  DailyReport?: DailyReport[] | [];
  FinalVerdict?: FinalVerdict[] | [];
  CoordinatorCommentDailyReport?: CoordinatorCommentsOnDailyReport[] | [];
  upload_charge_draft_info?: {
    file_name: string;
    file_url: string;
  };
  case_investigation_links?:
    | {
        id: number;
        investigation_file_info: InvestigationFile;
        linked_at: Date;
      }[]
    | [];
  evaluation_date?: Date;
  work_speed_evaluation?: number;
  work_quality_evaluation?: number;
  work_load_evaluation?: number;
  change_logs?: CaseChangeLog[] | [];
  respond_comments?: CaseRespondbackComment[] | [];
  charge_draft_history?: ChargeDraftHistory[] | [];
  is_RTD?: boolean;
  change_of_venue?: ChangeOfVenue[] | [];

  is_article_of_cahrge_changed?: boolean;
  reason_for_articel_of_charge?: string;

  out_of_jursdicition_source?: string;
  is_case_out_of_jurisdiction?: boolean;

  is_case_updated_by_court?: boolean;

  case_updated_by_court_date?: string;
  case_updated_by_court_reason?: string;

  assigned_prosecutor_name?: string;
  assigned_prosecutor_userid?: string | number;
  admin_unit_id?: string | number;
  org_id?: string | number;

  registration_number?: string;

  created_at?: Date;
}
export interface CaseDefendantLink {
  id?: number;
  defendant_number: number;
  defendant_info?: Suspect;
  case: CaseCreation | number;
  defendant?: Suspect | number;
}
export interface WitnessDefendants {
  id?: number;
  case?: CaseCreation | number;
  witnessed?: Witness | number;
  witnessed_info?: Witness;
  witnessed_defendants?: CaseDefendantLink[] | number[] | [];
  witnessed_defendants_info?: CaseDefendantLink[] | [];
}
export const PreJudgementDecision = {
  accept_charge: "Accept Charge",
  not_gulity: "Not Guilty",
  update_count: "Update Count",
  other: "Other",

  terminated_due_to_absence_of_defendant:
    "Terminated due to Absence of Defendant",
  considered_as_not_present: "Considered as Not Present",
  case_deferred_temporarily: "Case Deferred Temporarily",
};
export const PreJudgementDecisionForSelect = {
  accept_charge: "Accept Charge",
  not_gulity: "Not Guilty",
  update_count: "Update Count",
  other: "Other",
};
export interface PreJudgement {
  decision_date?: Date;
  summary?: string;
  decision?: keyof typeof PreJudgementDecision | null;
  remarks?: string;
  opening_case_file?: OpeniningCaseFile;
  defendant?: CaseDefendantLink;
  defendant_info?: CaseDefendantLink;
  count_defendant?: CountDefendantsList | number;
  count_defendant_info?: CountDefendantsList;
  has_alternate?: boolean;

  is_sworn?: boolean;
  is_refused_to_testify?: boolean;
}
export interface CountDefendantsList {
  id?: number;
  has_alternate?: boolean;
  count_number?: number;
  crime_type?: string;
  crime_type_category?: string;
  crime_level?: keyof typeof AlternativeCrimeLevel;
  prosecutor_decision?: string;
  prosecutor_decision_description?: string;
  articles_ofthe_charge?: string;
  alternate_crime_type?: string;
  alternate_crime_type_category?: string;
  alternate_crime_level?: keyof typeof AlternativeCrimeLevel;
  alternate_prosecutor_decision?: string;
  alternate_prosecutor_decision_description?: string;
  alternate_articles_ofthe_charge?: string;
  case?: CaseCreation | number;
  defendants?: CaseDefendantLink[] | number[] | [];
  defendants_info?: CaseDefendantLink[];

  is_count_changed_by_court?: boolean;
  chnaged_by_court_crime_type?: string;
  chnaged_by_court_crime_type_category?: string;
  chnaged_by_court_crime_level?: keyof typeof AlternativeCrimeLevel;
  chnaged_by_court_prosecutor_decision?: string;
  chnaged_by_court_prosecutor_decision_description?: string;
  chnaged_by_court_articles_ofthe_charge?: string;
  is_article_of_cahrge_changed?: boolean;
}
export const AlternativeCrimeLevel = {
  Heavy: "Heavy",
  Medium: "Medium",
  Light: "Light",
};
export interface DefendantCaseDetail {
  id: number;
  defendants: Suspect[] | number[] | [];
  witness: Witness[] | number[];
  case?: CaseCreation | number;
  upload_charge_draft_upload?: File | null;
  upload_charge_draft_details?: {
    dms_uuid: number;
    file_name: string;
    url: string;
  };
  prosecutor_registration_number?: string;
  incident_registration_no?: string;
  crime_refernce_number?: string;
  crime_type?: string;
  crime_type_catagory?: string;
  crime_level?: keyof typeof CrimeLevel | null;
  articles_ofthe_charge?: string;
  upload_charge_draft?: File | null;
  uuid_dms_upload_charge_draft?: string | null;
  prosecutor_decision?: string | null;
  prosecutor_decision_description?: string | null;
  status: keyof typeof DefendantCaseStatus;
  coordinator_comments_detail?: CommentOnCaseDraft[] | [];
  director_comments_detail?: DefendantCaseDetailDirectorComment[] | [];
}
export interface CommentOnCaseDraft {
  id?: number;
  case?: CaseCreation | number;
  role?: "coordinator" | "director" | "deputy" | "attorny_general";
  status?: "approved" | "rejected" | "respond_back";
  comment?: string;
  created_at?: Date;
  updated_at?: Date;
  created_by?: string;
  is_director_order_to_stop?: boolean;
}
export interface DefendantCaseDetailDirectorComment {
  id: number;
  comment: string;
  defendant_case_detail: DefendantCaseDetail | number;
  created_at?: Date;
}
export interface OpeniningCaseFile {
  id: number;
  defendants: Suspect[] | number[] | [];
  defendants_info?: Suspect[];
  status: keyof typeof OpeniningCaseFileStatus;
  assign_prosecutor: string;
  userid_assign_prosecutor?: string;
  prosecutor_registration_number: string;
  incident_registration_no: string;
  crime_refernce_number: string;
  court_type: string;
  court_level: string;
  court_registration_number: string;
  court_hearing_place: string;
  zone: string;
  city: string;
  sub_city: string;
  woreda: string;
  first_court_hearing_date: Date;
  reassign_prosecutor: string;
  is_venue_changed?: boolean;

  reassign_prosecutor_userid: "";
  case?: CaseCreation | number;
}
export interface DailyReport {
  id: number;
  opening_case_file: OpeniningCaseFile | number;
  defendants: Suspect[] | number[] | [];
  defendants_info?: Suspect[];
  status: keyof typeof DailyReportStatus | null;
  prosecutor_registration_number: string;
  incident_registration_no: string;
  crime_refernce_number: string;
  court_registration_number: string;
  next_trial_appointment: Date | null;
  report_date?: Date;
  appointment_type: string;
  appointment_reason: string;
  dailyreport_summary: string;
  court_order_for_next_appointment: string;
  is_final_verdict_given: boolean;
  case?: CaseCreation | number;
}
export interface CourtDecision {
  id?: number;
  court_decision: string;
}
export interface CourtDecisionType {
  id?: number;
  court_decision: string;
}
export interface ExhibitCondition {
  id?: number;
  name: string;
}
export interface FinalVerdict {
  id: number;
  prosecutor_registration_number: string;
  incident_registration_no: string;
  crime_refernce_number: string;
  court_registration_number: string;
  court_decision: CourtDecision | string;
  court_decision_amount: string;
  prosecutor_feedback_on_decision: string;
  court_decision_summary?: string;
  court_decision_type?: CourtDecisionType | string;

  is_alternate_charge: string;
  case_defendant_link: CaseDefendantLink | number;
  count_defendant: CountDefendantsList | number;
  case: CaseCreation | number;
  opening_case_file: OpeniningCaseFile | number;
  case_defendant_link_info?: CaseDefendantLink;
  count_defendant_info?: CountDefendantsList;
  has_alternate?: boolean;
}
export interface CoordinatorCommentsOnDailyReport {
  id?: number;
  comment: string;
  daily_report: DailyReport | number;
  case?: CaseCreation | number;
  role?: "coordinator" | "director" | "deputy" | "attorny_general";
  created_at?: Date;
  created_by: string;
}
export interface CrimeTypeBaseData {
  id?: number;
  name: string;
}
export interface CrimeCategoryBaseData {
  id?: number;
  name: string;
  crime_type: number;
}
export interface CrimeLevelBaseData {
  id?: number;
  level: string;
}
export interface CaseTerminationReasonBaseData {
  id?: number;
  reason: string;
}
export interface ProsecutorDecisionBaseData {
  id?: number;
  decision: string;
}
export interface CourtTypeBaseData {
  id?: number;
  type: string;
}
export interface CourtLevelBaseData {
  id?: number;
  level: string;
}
export interface AppointmentTypeBaseData {
  id?: number;
  appointment_type: string;
}
export interface ScreeningOutcomeBaseData {
  id?: number;
  outcome: string;
}
export interface AmendedDecisionBaseData {
  id?: number;
  decision: string;
}
export interface AmendedPunishmentBaseData {
  id?: number;
  punishment: string;
}
export interface ExibitProsecutionDecisionType {
  id?: number;
  name: string;
}
export interface ExibitCourtDecisionType {
  id?: number;
  name: string;
}
export interface ExternalPolice {
  id?: number;
  title: string;
  full_name: string;
  police_id_number: string | PoliceStation;
  police_station: string | PoliceStation;
  station_address: string;
  phone_number: string;
  username: string;
  email: string;
  police_station_id: any;
  role: keyof typeof ExternalUserRole | null;
  password: string;
  police_station_name?: string;
  confirm_password?: string;
  assigned_by_id: string;
}
export interface FurtherInvestigationFeedback {
  id?: number;
  feedback_text: string;
  created_by?: string;
  investigation_request: FurtherInvestigation | number | null;
}
export interface PoliceStation {
  id?: number;
  name: string;
  address: string;
  region: string;
  zone: string;
  woreda: string;
  kebele: string;
  house_number: string;
  city: string;
  admin_unit_id: string | number;
  org_id: string | number;
  organization?: {
    name: string;
    admin_unit: string;
  };
}
export const BailRightStatus = {
  submitted: "Submitted to Registrar",
  forwarded_to_coordinator: "Forwarded to Coordinator",
  assigned_to_prosecutor: "Assigned to Prosecutor",
  prosecutor_responded: "Prosecutor Responded",
  forwarded_to_registrar: "Forwarded to Registrar",
  bail_litigation: "Bail Litigation",
  bail_granted: "Bail Granted",
  bail_rejected: "Bail Rejected",
};
export const BailRightType = {
  on_court_hearing: "On Court Hearing",
  on_investigation: "On Investigation",
};
export interface BailRight {
  uu_id?: number;
  admin_unit_id?: string | number;
  suspect: number | null;
  suspect_info?: Suspect | null;
  // court_bail_application_file_upload?: File | null;
  prosecutor_document_upload?: File | null;
  receipt_of_payment_upload?: File | null;
  status: keyof typeof BailRightStatus;
  crime_registration_number?: string;
  incident_registration_number?: string;
  prosecutor_registration_number?: string;
  suspect_fullname?: string;
  suspect_gender?: string;
  suspect_age?: number | null;
  suspect_nationality?: string;
  suspect_identification_number?: string;
  crime_for_suspected?: string;
  current_imprisonment_location?: string;
  detention_start_date?: Date | null;
  court_bail_application_file?: File | null;
  court_registration_number?: string;
  bail_amount: number;
  bail_evidence_description?: string;
  court_name?: string;
  court_open_day?: Date | null;
  court_hearing_date?: Date | null;
  reference_number?: string;
  coordinator_assigned_prosecutor?: string;
  userid_coordinator_assigned_prosecutor?: string;
  coordinator_approved_recommendation?: "approve" | "respond_back";
  prosecutor_summary?: string;
  prosecutor_document?: File | null;
  bail_type?: keyof typeof BailRightType;
  daily_hearing_detail?: string;

  appointment_date?: Date | null;
  appointment_reason?: string;
  court_hearing?: string;
  court_order?: string;
  decision_action?: "grant" | "not_grant" | "pending";
  bail_stance?: "favored" | "opposed";
  final_outcome?: "approved" | "rejected";
  prosecutor_feedback?: string;
  to_appeal?: boolean;
  receipt_of_payment?: File | null;
  coordinator_feedbacks?: BailRightFeedback[];
  assign_prosecutor?: string;
  assign_prosecutor_userid?: string;

  documents?: DocumentSchema[];

  is_bail_prosecutor_approved?: boolean;

  crime_type?: string;

  created_at?: Date;
}
export interface BailRightFeedback {
  uu_id?: number;
  coordinator_user_id: number | string;
  coordinator_fullname: string;
  comment: string;
  decision: "approve" | "respond_back";
  created_at?: Date;
  bail_right: number;
}
export interface BailHearingDecision {
  uu_id?: number;
  receipt_of_payment_upload?: File | null;
  receipt_of_payment_details?: { file_name: string; url: string };
  daily_hearing_detail?: string;
  if_final_decision_given: boolean;
  bail_right: BailRight | number | null;

  appointment_date?: Date | string | null;
  appointment_reason?: string;
  court_hearing?: string;
  court_order?: string;
  decision_action?: "grant" | "not_grant" | "pending";
  bail_stance?: "favored" | "opposed" | "favored_rejected" | undefined;
  final_outcome?: "approved" | "rejected";
  prosecutor_feedback?: string;
  to_appeal?: boolean;
  receipt_of_payment?: File | null;
  court_decision_document?: File | null;
  assign_prosecutor?: string;
  assign_prosecutor_userid?: string;
  bail_amount?: number | string;

  hearing_documents?: DocumentSchema[];
  created_at?: Date;
}
export interface SuspectTowitness {
  id?: number;
  suspect: string | number;
  agreement_with_suspect_file: File | null;
  revocation_file?: File | null;
  status: keyof typeof SuspectToWitnessStatus;
  crime_registration_number: number | string;
  incident_registration_number: number | string;
  prosecutor_registration_number: number | string;
  agreement_with_suspect: boolean;
  request_date: Date | string | null;
  decision: keyof typeof SuspectToWitnessDecision | null;
  conversion_summary: string;
  revocation_summary?: string;
  revocation_decision: keyof typeof SuspectToWitnessDecision | null;
  immunity_revoked?: boolean;
  revocation_reason?: string;
  revoked_by_attorney_general?: boolean;
  prosecutor_name?: string;
  prosecutor_user_id?: string;
  registration_number?: string;
  registration_date?: Date | string | null;
  org_unit_id?: string;
  admin_unit_id?: string;
  suspect_info?: Suspect;
  agreement_with_suspect_file_info?: DocumentInfo;
  revocation_file_info?: DocumentInfo | null;
  respond_back_comments?: SuspectToWitnessFeedback[] | [];
  documents?: DocumentSchema[];
  org_id?: string;
}
export const SuspectToWitnessStatus = {
  Pending: "Pending",
  Respond_Back_prosecutor: "Respond Back Prosecutor",
  forwarded_to_cordinator: "Forwarded to Cordinator",
  forwarded_to_attorney_general: "Forwarded to Attorny General",
  forwarded_to_head_of_attorney_general:
    "Forwarded to Head of Attorney’s Office",
  forwarded_to_registrar: "Forwarded to Registrar",
  sent_to_court: "Sent To Court",
};
export const SuspectToWitnessDecision = {
  Pending: "Pending",
  Approved: "Approved",
  Respond_Back: "RespondBack",
  Rejected: "Rejected",
};
export interface CaseChangeLog {
  id: number;
  field_changed: string;
  old_value: keyof typeof CaseStatus;
  new_value: keyof typeof CaseStatus;
  changed_by: string | null;
  timestamp: Date;
  case: number;
}
export const DoubtfulCaseStatus = {
  Pending: "Pending",
  Approved: "Approved",
  Rejected: "Rejected",
  Resolved: "Resolved",
  forwarded_to_cordinator: "Forwarded to Cordinator",
  assigned_to_team_asking: "Assigned to Team Asking",
  forwarded_to_registrar: "Forwarded to Registrar",
  "Pending_for-giving": "Pending for Giving",
  forwarded_to_cordinator_giving: "Forwarded to Cordinator",
  assigned_to_team_giving: "Assigned to Team Giving",
  forwarded_to_registrar_aftergiving: "Forwarded to Registrar",
  respond_backto_prosecutor: "Respond Back to Prosecutor",
};
export interface DoubtfulCase {
  id?: number;
  draft_document?: File | null;
  team_final_instruction_summary_attchement?: File | null;
  team_resolution_summary_document?: File | null;
  investigation_file_id?: InvestigationFile | number | null;
  request_status?: keyof typeof DoubtfulCaseStatus | null;
  crime_registration_number?: string | null;
  incident_registration_number?: string | null;
  prosecutor_registration_number?: string | null;
  requesting_prosecutor?: string | null;
  requesting_prosecutor_user_id?: string | null;
  requesting_prosecutor_admin_unit?: string | null;
  instruction_description?: string | null;
  requested_date?: Date | null;
  registrar_refernece_no_out?: string | null;
  team_resolution_summary?: string | null;
  team_resolution_summary_date?: Date | null;
  team_draft_summary?: string | null;
  team_draft_date?: Date | null;
  requesting_office_admin_unit?: string | null;
  requesting_office_org_unit?: string | null;
  team_final_instruction_summary?: string | null;
  team_final_instruction_date?: Date | null;
  registrar_refernece_out?: string | null;
  giving_direction_office_admin_unit?: string | null;
  giving_direction_office_org_unit?: string | null;

  asking_team_members?: TeamMemberAsking[] | [];
  giving_team_members?: TeamMemberGiving[] | [];
  draft_document_info?: DocumentInfo;
  team_resolution_summary_document_info?: DocumentInfo;
  team_final_instruction_summary_attchement_info?: DocumentInfo;
  instruction_feedbacks?: DoubtfulCaseFeedback[] | [];

  instruction_description_document?: File | null;
  instruction_description_document_info?: DocumentInfo | null;

  org_id?: string;
  admin_unit_id?: string;
  transferred_from_admin_unit_id?: string;
  documents?: DocumentSchema[];
}
interface DocumentInfo {
  file_name: string;
  file_url: string;
}
export interface TeamMemberAsking {
  id?: number;
  name: string;
  admin_unit_id: string;
  is_team_leader: boolean;
  instruction: DoubtfulCase | number | null;
}
export interface TeamMemberGiving {
  id?: number;
  name: string;
  admin_unit_id: string;
  is_team_leader: boolean;
  instruction: DoubtfulCase | number | null;
}
export interface DoubtfulCaseFeedback {
  id?: number;
  if_for_asking: boolean;
  feedback_type: "Prosecutor" | "TeamMemberAsking" | "TeamMemberGiving";
  feedback_text: string;
  status: "Pending" | "Approved" | "Rejected" | "Respond_Back";
  instruction: DoubtfulCase | number | null;
}
export interface SuspectToWitnessFeedback {
  type: "initial" | "revocation";
  respondback_feedback: File | null;
  comment: string;
  submitted_by: string;
  conversion: SuspectTowitness | number;
}
export interface CaseRespondbackComment {
  role: keyof typeof RolesForComment;
  upload_feedback: File | null;
  upload_feedback_info?: DocumentInfo;
  status: "respond_back";
  comment: string;
  case: CaseCreation | number | null;
  documents?: DocumentSchema[];
}
export const RolesForComment = {
  coordinator: "Coordinator",
  director: "Director",
  deputy: "Deputy",
  attorny_general: "Attorney General",
};
export interface ChargeDraftHistory {
  file: string | File | null;
  uploaded_by: string;
  case: CaseCreation | number | null;
  uploaded_at?: Date;
}
export interface AdminUnitDetail {
  uu_id?: string;
  hierarchy_level?: {
    uu_id?: string;
    name?: string;
    display_name?: string;
  };
  unit_name?: string;
  structure_level?: string;
  is_regiometropolitan?: boolean;
  description?: string;
  parent_unit?: string;
}
export interface ChangeOfVenue {
  id?: number;
  summary_file?: File | null;
  reason_summary?: string;
  date?: Date;
  prosecution_case_number?: string;
  court_case_number?: string;
  registration_number?: string;
  status?: keyof typeof ChangeOfVenueStatus;
  case?: CaseCreation | number | null;
  summary_file_info?: {
    file_name: string;
    file_url: string;
  };
  crime_registration_number?: string;
  incident_registration_number?: string;
  feedbacks?: VenueFeedback[];
  file_history?: {
    change_of_venue: number;
    id: string;
    uploaded_at: string;
    uploaded_by: string;
    uploaded_file: string;
  }[];
}
export const ChangeOfVenueStatus = {
  pending: "Pending",
  forwarded_to_coordinator: "Forwarded to Coordinator",
  forwarded_to_registrar: "Forwarded to Registrar",
  approved: "Approved",
  respond_back_to_prosecutor: "Respond Back to Prosecutor",
};
export interface VenueFeedback {
  action: keyof typeof VenueFeedbackAction;
  comment: string;
  created_by: string;
  change_of_venue: ChangeOfVenue | number;
}
export const VenueFeedbackAction = {
  respond_back_to_prosecutor: "Respond Back to Prosecutor",
  notified: "Notified",
  reviewed: "Reviewed",
};
export interface PettyOffenceDecisionTypeList {
  id?: number;
  name?: string;
}
export interface AppealRequest {
  id?: number;
  documents?: DocumentSchema[];
  defendant_ids?: number[] | string[];
  defendants?: CaseDefendantLink[];
  appeal_type: keyof typeof AppealRequestType;
  reason?: string;
  crime_registration_number?: string;
  incident_registration_number?: string;
  prosecutor_registration_number?: string;
  court_registration_number?: string;
  appeal_summary_text?: string;
  appeal_summary_files?: File | null;
  lower_court_type?: string;
  lower_court_location?: string;
  lower_court_level?: string;
  lower_court_hearing_date?: Date;
  lower_registration_number?: string;
  lower_registration_date?: Date;
  lower_court_name?: string;
  lower_court_zone?: string;
  lower_court_woreda?: string;
  higher_court_type?: string;
  higher_court_location?: string;
  higher_court_level?: string;
  higher_court_hearing_date?: Date;
  higher_court_name?: string;
  higher_court_zone?: string;
  higher_court_woreda?: string;
  registration_number?: string;
  registration_date?: Date;
  court_appeal_number?: string;
  court_summons?: File | null;
  opening_date?: Date;
  first_hearidng_date?: Date;
  assigned_prosecutor?: string;
  assigned_prosecutor_id?: string;
  requesting_prosecutor?: string;
  requesting_prosecutor_id?: string;
  admin_unit_id?: string;
  org_unit_id?: string;
  previous_admin_unit_id?: string;
  previous_org_unit_id?: string;
  status: keyof typeof AppealRequestStatus;
  coordinator_status?: keyof typeof AppealRequestCoordinatorStatus;
  case_id?: number;
  case?: CaseCreation;
  count_id?: number;
  count?: CountDefendantsList;
  final_verdict_id?: number;
  final_verdict?: FinalVerdict;
  created_at?: Date;
  normal_feedbacks?: [];
  respondback_feedbacks?: [];
  higher_admin_feedbacks?: [];
  pre_judgement_entries?: AppealPreJudgement[];
  daily_report?: AppealDailyReport[];
  appeal_final_verdict?: AppealFinalVerdict[];
  crime_type?: string;
  bail_right_id?: number;
  bail_right?: BailRight;
  parent_appeal?: number;
  defendent_name_if_bail_right?: string;
  defendant_appeal_request_id?: string;

  is_cassation?: boolean;
}
export const AppealRequestStatus = {
  PENDING: "Pending",
  FORWARDED_TO_REGISTRAR: "Forwarded to Registrar",
  FORWARDED_TO_COORDINATOR: "Forwarded to Coordinator",
  SUBMITTED_TO_COURT: "Submitted to Court",
  COORDINATOR_RESPONDED_BACK: "Coordinator Responded Back",
  ASSIGNED_TO_PROSECUTOR: "Assigned to Prosecutor",
  FORWARDED_TO_HIGHER_REGISTRAR: "Forwarded to Higher Registrar",
  FORWARDED_TO_HIGHER_CLERK: "Forwarded to Higher Clerk",
  FORWARDED_TO_HIGHER_COORDINATOR: "Forwarded to Appeal Coordinator",
  RESPONDED_BACK_TO_PROSECUTOR: "Responded Back to Prosecutor",
  COMPLETED: "Feedback Provided by Higher Admin",
};
export const AppealRequestCoordinatorStatus = {
  PENDING: "Pending",
  APPROVED: "Approved",
  RESPOND_BACK: "Respond Back",
};
export const AppealRequestType = {
  PRE_JUDGEMENT: "Pre-Judgement",
  FINAL_VERDICT: "Final Verdict",
  BAILRIGHT: "Bail Right",
  Case: "Case",
  ReAppealCase: "Re-Appeal Case",
};
export interface AppealNormalFeedback {
  actor: keyof typeof AppealNormalFeedbackActor;
  feedback_text: string;
  feedback_file?: File | null;
  appeal_request?: AppealRequest | number;
  defendant_appeal_request?: DefendantAppeal | number;
  created_at?: Date;
  documents?: DocumentSchema[];
}
export const AppealNormalFeedbackActor = {
  COORDINATOR: "Coordinator",
  REGISTRAR: "Registrar",
  HIGHER_COURT: "Higher",
  PROSECUTOR: "Prosecutor",
  OTHER: "Other",
};
export interface AppealRespondBackComment {
  actor: keyof typeof AppealNormalFeedbackActor;
  feedback_text: string;
  feedback_file: File | number;
  status: "PENDING" | "RESPONDED";
  appeal_request: AppealRequest | number;
  defendant_appeal_request?: DefendantAppeal[];
}
export interface HigherAdminFeedbackRequest {
  id?: number;
  crime_type?: string;
  requested_by?: string;
  requested_by_id?: string;
  request_summary?: string;
  request_file?: File | null;
  coordinator_status?: keyof typeof AppealRequestCoordinatorStatus;
  higher_coordinator_status?: keyof typeof AppealRequestCoordinatorStatus;
  registrar_number?: string;
  registrar_date?: Date;
  assigned_prosecutor?: string;
  assigned_prosecutor_id?: string;
  higher_admin_feedback?: string;
  higher_admin_feedback_file?: File | null;
  higher_admin_feedback_date?: Date;
  status: keyof typeof HigherAdminFeedbackRequestStatus;
  admin_unit_id?: string;
  org_unit_id?: string;
  previous_admin_unit_id?: string;
  previous_org_unit_id?: string;
  appeal_request: AppealRequest | number;
  respondback_feedbacks?: HigherAdminFeedback[];
  created_at?: Date;
  documents?: DocumentSchema[];
}
export const HigherAdminFeedbackRequestStatus = {
  PENDING: "Pending",
  FORWARDED_TO_COORDINATOR: "Forwarded to Coordinator",
  COORDINATOR_APPROVED: "Coordinator Approved",
  COORDINATOR_RESPOND_BACK: "Coordinator Responded Back",
  FORWARDED_TO_REGISTRAR: "Forwarded to Registrar",
  SUBMITTED_TO_HIGHER_ADMIN: "Submitted to Higher Admin",
  FORWARDED_TO_HIGHER_REGISTRAR: "Forwarded to Higher Registrar",
  FORWARDED_TO_HIGHER_COORDINATOR: "Forwarded to Higher Coordinator",
  ASSIGNED_TO_PROSECUTOR: "Assigned to Prosecutor",
  RESPONDED_BACK_TO_PROSECUTOR: "Responded Back to Prosecutor",
  COMPLETED: "Feedback Provided by Higher Admin",
};
export interface HigherAdminFeedback {
  feedback_text: string;
  feedback_file?: File | null;
  feedback_by: string;
  feedback_by_id: string;
  feedback_request: HigherAdminFeedbackRequest | number;
  created_at?: Date;
}
export interface AppealPreJudgement {
  id?: number;
  decision_date?: Date;
  summary?: string;
  decision?: string | null;
  remarks?: string;
  appeal_request?: AppealRequest | number;
  defendant_appeal_request?: DefendantAppeal | number;
}
export const AppealPreJudgementDecision = {
  accept_appeal: "Accept Appeal",
  reect_appeal: "Not Gulity",
  update_appeal_request: "Update Appeal Request",
  other: "Other",
};
export interface AppealDailyReport {
  id?: number;
  status?: keyof typeof AppealDailyReportStatus;
  report_date?: Date;
  next_trial_appointment?: Date;
  appointment_type?: string;
  appointment_reason?: string;
  dailyreport_summary?: string;
  court_order_for_next_appointment?: string;
  is_final_verdict_given?: boolean;
  appeal_request?: AppealRequest | number;
  defendant_appeal_request?: AppealRequest | number;
  coordinator_comments?: FeedbackOnAppealDailyReport[];
}
export interface FeedbackOnAppealDailyReport {
  id?: number;
  comment: string;
  daily_report: DailyReport | number;
  appeal_request?: AppealRequest | number;
  defendant_appeal_request?: DefendantAppeal | number;
  role?: keyof typeof AppealDailyReportFeedbackActor;
  created_at?: Date;
  created_by: string;
}
export const AppealDailyReportFeedbackActor = {
  coordinator: "Coordinator",
  director: "Director",
  deputy: "Deputy",
  attorny_general: "Attorney General",
};
export const AppealDailyReportStatus = {
  pending: "Pending",
  scheduled: "Scheduled",
  decision_provided: "Decision Provided",
};
export interface AppealFinalVerdict {
  id?: number;
  defendant_ids?: number[] | string[];
  defendants?: CaseDefendantLink[];
  court_decision_summary?: string;
  amended_court_decision_type?: keyof typeof AmmendedCourtDecisionType;
  amended_court_decision?: string;
  amended_court_decision_amount?: string;
  prosecutor_feedback_on_decision?: string;
  appeal_request?: AppealRequest | number;
  defendant_appeal_request?: AppealRequest | number;
  defendant_name?: string;
  court_decision_file?: File | string | null;
  documents?: DocumentSchema[];
}
export const AmmendedCourtDecisionType = {
  UPHELD: "Upheld (Original decision stands)",
  OVERTURNED: "Overturned (Reversed)",
  MODIFIED: "Modified (Partially changed)",
  REMANDED: "Remanded (Sent back to lower court)",
};
export const AppealFinalVerdictDecisionSummary = {
  UPHELD: "Upheld (Original decision stands)",
  OVERTURNED: "Overturned (Reversed)",
  MODIFIED: "Modified (Partially changed)",
  REMANDED: "Remanded (Sent back to lower court)",
};

export const CrimeTypeForCountAndAppeal = {
  economic: "Economic Crime",
  corruption: "Corruption Crime",
  various: "Various Crime",
  child_and_women: "Child and Women",
};
export interface DefendantAppeal {
  id?: number;
  documents?: DocumentSchema[];
  higher_court_type?: string;
  higher_court_level?: string;
  higher_court_hearing_date?: Date | null;
  court_zone?: string;
  court_woreda?: string;
  court_appeal_number?: string;
  court_summons?: File | null;
  opening_date?: Date | null;
  first_hearidng_date?: Date | null;
  assigned_prosecutor?: string;
  assigned_prosecutor_id?: string;
  response_summary?: string;
  response_file?: File | null;
  coordinator_status?: keyof typeof AppealRequestCoordinatorStatus;
  registrar_number?: string;
  registrar_date?: Date | null;
  status?: keyof typeof DefendantAppealStatus;
  admin_unit_id?: string;
  org_unit_id?: string;
  parent_appeal?: string | null;
  case_id?: number | string;
  case?: CaseCreation;
  count_id?: number | string;
  count?: CountDefendantsList;
  defendants?: CaseDefendantLink[];
  defendant_ids?: number[] | string[];
  pre_judgement?: AppealPreJudgement[];
  daily_report_defendant?: AppealDailyReport[];
  final_verdict_defendant?: AppealFinalVerdict[];
  bail_right_id?: number;
  bail_right?: BailRight;
  normal_feedbacks_defendant?: AppealNormalFeedback[];
  respondback_feedbacks_defendant?: AppealNormalFeedback[];
  defendent_name_if_bail_right?: string;
  court_summon?: File | null;
  crime_type?: string | null;
  // Backend field name is `is_casations` (sic).
  is_casations?: boolean;
  originating_prosecutor_appeal?: string | null;
}
export const DefendantAppealStatus = {
  PENDING: "Pending",
  FORWARDED_TO_COORDINATOR: "Forwarded to Coordinator",
  ASSIGNED_TO_PROSECUTOR: "Assigned to Prosecutor",
  RESPONSE_PREPARED_BY_PROSECUTOR: "Response Prepared to Prosecutor",
  COORDINATOR_FEEDBACK: "Coordinator Feedback",
  RESPONDED_BACK_TO_REGISTRAR: "Responded Back to Registrar",
  FORWARDED_TO_COURT: "Forwarded to Court",
  COMPLETED: "Completed",
};
export interface CaseRelation {
  id?: number;
  relation_type: "merged_from" | "split_from";
  from_case: number | CaseCreation;
  to_case: number | CaseCreation;
}
export interface WitnessProtection {
  id?: number;
  witnesses?: WitnessForWitnessProtection[];
  documents?: DocumentSchema[];
  id_card_attachment?: File | null;
  id_card_attachment_info?: {
    file_name: string;
    file_url: string;
  };
  petition_document?: File | null;
  petition_document_info?: {
    file_name: string;
    file_url: string;
  };
  supplementary_document?: File | null;
  supplementary_document_info?: {
    file_name: string;
    file_url: string;
  };
  decision_file?: File | null;
  decision_file_info?: {
    file_name: string;
    file_url: string;
  };
  agreement_document?: File | null;
  agreement_document_info?: {
    file_name: string;
    file_url: string;
  };
  admin_unit?: string;
  status?: keyof typeof WitnessProtectionStatus;
  crime_type?: keyof typeof CrimeTypeForCountAndAppeal;
  applicant_full_name?: string;
  applicant_region?: string;
  applicant_city?: string;
  applicant_woreda?: string;
  applicant_phone_number?: string;
  applicant_id_card_number?: string;
  submission_method?: string;
  court_registration_number?: string;
  protection_request_reason?: string;
  remark?: string;
  protection_type?: string;
  assign_prosecutor_name?: string;
  assign_prosecutor_id?: string;
  prosecutor_feedback?: string;
  decision_status?: keyof typeof WitnessProtectionDecision;
  decision_summary?: string;
  date_signed?: Date;
  protection_agreement_time_period?: string;
  protection_agreement_time_period_begin_date?: Date;
  protection_agreement_time_period_end_date?: Date;
  grievance_submitted?: boolean;
  grievance_description?: string;
  new_decision_summary?: string;
  security_organization_involved?: string;
  monitoring_details?: string;
  created_at?: Date;
}
export const WitnessProtectionStatus = {
  Pending: "Pending",
  "Forwarded to Coordinator": "Forwarded to Coordinator",
  "Forwarded to Director": "Forwarded to Director",
  "Forwarded to Deputy": "Forwarded to Deputy",
  "Assigned to Prosecutor": "Assigned to Prosecutor",
};
export const WitnessProtectionDecision = {
  Granted: "Granted",
  Rejected: "Rejected",
  Pending: "Pending",
};
export interface WitnessForWitnessProtection {
  id?: number;
  witness_full_name?: string;
  witness_age?: number;
  witness_gender: keyof typeof Gender;
  witness_region?: string;
  witness_zone?: string;
  witness_woreda?: string;
  witness_phone_number?: string;
  created_at?: Date;
  protection_request: number;
}
export const FILE_URL = {
  REPORTER: "legal-entity/reporter-documents/document/",
  SUSPECT: "legal-entity/suspect-documents/document/",
  WITNESS: "legal-entity/witness-documents/document/",
  VICTIM: "legal-entity/victim-documents/document/",
  EVIDENCE: "crime-reference/crime-evidence-documents/document/",
  EXIBIT: "crime-reference/crime-exhibit-documents/document/",
  RECEIVING_INVESTIGATION:
    "prosecutor-police/receiving-investigation-file-documents/document/",
  FURTHER_INVESTIGATION:
    "prosecutor-police/further-investigation-request-documents/document/",
  CASE_CREATION: "crime_case_management/case-documents/document/",
  COURT_APPLICATION:
    "crime_case_management/court-application-documents/document/",
  REMAND: "crime_case_management/remand-documents/document/",
  EXECUTION: "crime_case_management/execution-documents/document/",
  APPEAL: "appeal/fresh_appeal-request-documents/document/",
  APPEAL_RESPOND_BACK_FEEDBACK:
    "appeal/respondback-feedback-documents/document/",
  APPEAL_NORMAL_FEEDBACK: "appeal/normal-feedback-documents/document/",
  DOUBTFUL_CASE:
    "Doubtful_Cases/instruction_on_doubtful_case_documents/document/",
  BAIL_RIGHT: "bail_right/bail-right-documents/document/",
  WITNESS_PROTECTION:
    "witness_protection/witness_protection_request_documents/document/",
  DEFENDANT_APPEAL: "appeal/defendant-appeal-request-documents/document/",
  APPEAL_FINAL_VERDICT: "appeal/appeal-final-verdict-documents/document/",
  APPEAL_APPLICATION: "appeal/appeal-application-documents/document/",
  DIRECTOR_FEEDBACK: "director/director-feedback-documents/document/",
  SCREENING: "crime-reference/screening-team-finding-documents/document/",
  INVESTIGATION: "crime-reference/investigation-documents/document/",
  SUSPECT_TO_WITNESS: "crime_case_management/conversion-documents/document/",
  RESPOND_BACK_ON_CASE:
    "crime_case_management/respinsbac_comment-on-case-drafts/document/",
  FEEBACK_FILES:
    "crime_case_management/respond-back-comment-documents/document/",
  HIGHER_ADMIN_FEEDBACK:
    "appeal/higher-admin-feedback-request-documents/document/",
  HIGHER_ADMIN: "appeal/higher-admin-feedback-request-documents/document/",
  PRIVATE_PROSECUTION:
    "prosecutor-police/private-prosecution-documents/document/",
};

// ASSET

export type AssetAppeal = {
  id: string;
  appeal_documents: File[];
  respondent_documents: File[];
  feedbacks: AssetAppealFeedback[];
  readOnly: true;
  daily_final_reports: AssetRecoveryDailyFinalReport[];
  appeal_type: string;
  appeal_claim_summary: string | null;
  date_submitted: string | null;
  action_status: AssetAppealRequestActionStatusEnum | null;
  forwarding_status: AppealRequestForwardingStatusEnum | null;
  admin_unit: string | null;
  org_unit: string | null;
  requesting_prosecutor_id: string | null;
  requesting_prosecutor_name: string | null;
  assigned_prosecutor_id: string | null;
  assigned_prosecutor_name: string | null;
  lower_court_name: string | null;
  lower_court_type: string | null;
  lower_court_level: string | null;
  lower_registration_number: string | null;
  lower_registration_date: string | null;
  higher_court_name: string | null;
  higher_court_type: string | null;
  higher_court_level: string | null;
  higher_court_hearing_date: string | null;
  court_name: string | null;
  court_type: string | null;
  court_level: string | null;
  court_hearing_date: string | null;
  registration_number: string | null;
  registration_date: string | null;
  first_hearidng_date: string | null;
  court_appeal_number: string | null;
  court_summons: File[] | null;
  opening_date: string | null;
  first_hearing_date: string | null;
  asset_referral: Referral | null;
  asset: Asset | null | Asset[];
  assets: Asset[] | null;
  parent_appeal?: string | null;
  appeal_response_summary?: string | null;
  prosecutor_response_file?: File[];
};
export enum AssetAppealRequestActionStatusEnum {
  PENDING = "Pending",
  APPEAL_REQUESTED = "Appeal Requested",
  APPEAL_APPROVED = "Appeal Approved",
  APPEAL_REJECTED = "Appeal Rejected",
  APPEAL_RESPONDED = "Appeal Responded",
  APPEAL_SUBMITTED_TO_COURT = "Appeal Submitted To Court",
  APPEAL_ON_LITIGATION = "Appeal On Litigation",
  APPEAL_FINAL_DECISION = "Appeal Final Decision",
  APPEAL_UPDATED = "Appeal Updated",
}

export enum AppealRequestForwardingStatusEnum {
  PENDING = "Pending",
  FORWARDED_TO_COORDINATOR = "Forwarded To Coordinator",
  ASSIGNED_TO_PROSECUTOR = "Assigned To Prosecutor",
  FORWARDED_TO_REGISTRAR = "Forwarded To Registrar",
  FORWARDED_TO_HIGHER_REGISTRAR = "Forwarded To Higher Registrar",
  FORWARDED_TO_HIGHER_COORDINATOR = "Forwarded To Higher Coordinator",
}

export enum RespondentAssetAppealStatusEnum {
  PENDING = "Pending",
  APPEAL_REQUESTED = "Appeal Requested",
  APPEAL_APPROVED = "Appeal Approved",
  APPEAL_REJECTED = "Appeal Rejected",
  APPEAL_RESPONDED = "Appeal Responded",
  APPEAL_UPDATED = "Appeal Updated",
  APPEAL_SUBMITTED_TO_COURT = "Appeal Submitted To Court",
  APPEAL_ON_LITIGATION = "Appeal Under Litigation",
  APPEAL_FINAL_DECISION = "Appeal Final Decision",
  RESPONSE_SUBMITTED = "Response Summited",
  RESPONSE_APPROVED = "Response Approved",
  RESPONSE_RESPOND_BACK = "Response Respond Back",
  RESPONSE_UPDATED = "Response Updated",
  RESPONDENT_APPEAL_ON_LITIGATION = "Respondent Appeal On Litigation",
  RESPONDENT_APPEAL_DECISION_ISSUED = "Respondent Appeal Decision Issued",
}
export type AssetRecoveryDailyFinalReport = {
  id: string;
  daily_report_documents: File[];
  court_decision_documents: File[];
  court_hearing_date: string | null;
  daily_report_summary: string | null;
  court_order_for_next_appointment: string | null;
  next_appointment_reasons: string[] | null;
  next_appointment_date: string | null;
  is_next_appointment_reason_final_verdict: boolean | null;
  court_decision_summary: string | null;
  prosecutor_feedback_on_prohibition_decision: string | null;
  court_decision_date: string | null;
  is_appealed: boolean | null;
};

export enum FeedbackRoleEnum {
  PROSECUTOR = "Prosecutor",
  COORDINATOR = "Coordinator",
  DIRECTOR = "Director",
  DEPUTY_HEAD = "Deputy Head",
  HEAD = "Head",
  OTHER = "Other",
}

export enum FeedbackTypeEnum {
  normal = "Normal Feedback",
  respond_back = "Respond Back",
}
export enum AssetAppealFeedbackRespondbackTypeEnum {
  ASSET_APPEAL_REQUEST = "Asset Appeal Request",
  RESPONDENT_APPEAL_RESPONSE = "Respondent Appeal Response",
}

export type AssetAppealFeedback = {
  id?: string;
  feedback_documents: File[];
  feedback_type: FeedbackTypeEnum;
  respondback_type: AssetAppealFeedbackRespondbackTypeEnum;
  role: FeedbackRoleEnum;
  feedback_summary: string;
  feedback_date: string;
  given_by_user_id: string;
  given_by_name: string;
  created_at: string;
  asset_appeal_request: string;
};

export enum AssetReferralForwardingStatusEnum {
  ASSIGNED_TO_PROSECUTOR = "Assigned to Prosecutor",
  FORWARDED_TO_COORDINATOR = "Forwarded to Coordinator",
  FORWARDED_TO_REGISTRAR = "Forwarded to Registrar",
}

export enum AssetReferralActionStatusEnum {
  PENDING = "Pending",
  FORWARDED_TO_LOWER = "Forwarded to Lower",
  FORWARDED_TO_HIGHER = "Forwarded to Higher",
  INVESTIGATION_ONGOING = "Investigation Ongoing",
  PROHIBITION_REQUESTED = "Prohibition Requested",
  PROHIBITION_REQUEST_APPROVED = "Prohibition Request Approved",
  PROHIBITION_ON_REVISION = "Prohibition On Revision",
  PROHIBITION_ON_UPDATED = "Prohibition Updated",
  PROHIBITION_ON_LITIGATION = "Prohibition On litigation",
  PROHIBITION_FINAL_VERDICT = "Prohibition Final Verdict",
  ASSET_RECOVERY_REQUESTED = "Asset Recovery Requested",
  ASSET_RECOVERY_REQUEST_APPROVED = "Asset Recovery Request Approved",
  ASSET_RECOVERY_ON_REVISION = "Asset Recovery On Revision",
  ASSET_RECOVERY_UPDATED = "Asset Recovery Updated",
  ASSET_RECOVERY_ON_LITIGATION = "Asset Recovery On Litigation",
  ASSET_RECOVERY_FINAL_VERDICT = "Asset Recovery Final Verdict",
  COURT_CASE_FILED = "Court Case Filed",
  EXECUTION_IN_PROGRESS = "Execution in Progress",
  RECOVERED = "Recovered",
  CLOSED_BY_COORDINATOR = "Closed by Coordinator",
  CLOSED_BY_PROSECUTOR = "Closed by Prosecutor",
  TERMINATION_REQUESTED = "Termination Requested",
  TERMINATION_REJECTED = "Termination Rejected",
  TERMINATED_BY_PROSECUTOR = "Terminated By Prosecutor",
  SUSPENSION_REQUESTED = "Suspension Requested",
  SUSPENDED = "Suspended",
  SUSPENSION_REJECTED = "Suspension Rejected",
  REINITIATE_REQUESTED = "Reinitiate Requested",
  REINITIATE_REJECTED = "Reinitiate Rejected",
  REINITIATE_APPROVED = "Reinitiate Aproved",
}

export interface ReferralRespondBack {
  id: string;
  feedback_file_details: {
    file_name: string;
    url: string;
    uploaded_at: string;
  } | null;
  feedback_type: string | null;
  respondback_type: string | null;
  role: string | null;
  feedback_summary: string;
  feedback_file: string | null;
  feedback_date: string;
  given_by_user_id: string;
  given_by_name: string;
  created_at: string;
  referral: string;
}
interface HistoryRecord {
  id: string;
  old_action_status: string;
  new_action_status: string;
  old_admin_unit_id: string;
  new_admin_unit_id: string;
  old_org_unit_id: string;
  new_org_unit_id: string;
  changed_by: string;
  changed_at: string;
  referral: string;
}

export type AssetWitenes = {
  id?: string;
  person: Person | null;
  person_id: string;
  testimony_summary?: string;
  referral?: string;
};

export type AssetReporter = {
  id?: string;
  person: Person | null;
  person_id?: string;
  relationship_to_case?: string;
  referral?: string;
};
export interface ReferralFormData {
  reception_method: string;
  letter_number: string;
  date: string;
  letter_info: string;
  reception_method_others?: string;
  registerd_by?: string | null;
  admin_unit_id?: string | null;
  org_unit_id?: string | null;
  action_status?: string;
  registerd_by_user_id?: string | null;
  receiving_office?: string | null;
  referal_summary?: string | null;
  prohabition_request_registration_number?: string | null;
  letter_file?: File[] | null;
}

export interface ProhibitionFormData {
  prohabition_request_registration_number: string | null;
  prohabiton_request_date_registrar: string | null;
}
export interface RecoveryFormData {
  asset_recovery_request_registration_number: string | null;
  asset_recovery_request_date_registrar: string | null;
  action_status?: string;
}
export type EntityType =
  | "evidence"
  | "owner"
  | "suspect"
  | "reporter"
  | "victim"
  | "witness";

export interface Referral {
  org_unit: any;
  id: string;
  referral_id: string;
  is_prohabition_requested: boolean;
  registerd_by: string;
  reporters: AssetReporter[];
  witnesses: AssetWitenes[];
  owners: Owner[];
  victims: AssetVictim[];
  suspects: AssetSuspect[];
  evidences: ReferralEvidence[];
  assets: Asset[];
  letter_file_details: string;
  decision_document_details: {
    file_name: string;
    url: string;
    uploaded_at: string;
  };
  history_records: HistoryRecord[];
  forward_status: "Assigned to Prosecutor" | string;
  action_status: "Pending" | string;
  receiving_office: string;
  reception_method: string;
  letter_files: File[];
  letter_number: string;
  date: string;

  assigned_prosecutor: string;
  assigned_prosecutor_user_id: string;
  admin_unit_id: string;
  org_unit_id: string;
  coordinator_remark: string;
  decision_document: File[];
  prohibition_request_document: File[];
  decision_summary: string;
  decision_date?: string;
  created_at: string;
  updated_at: string;
  letter_info?: string;
  investigation_summary?: string;
  investigation_summary_file?: File | null;
  referal_summary?: string | null;
  file_histories?: [
    {
      id?: string;
      file_type: string;
      old_file: string | null;
      new_file: string | null;
      new_date: string | null;
      changed_by: string | null;
      changed_at: string | null;
      referral: string | null;
    },
  ];
  investigation_summary_files:
    | [
        {
          file_name: string;
          url: string;
          uploaded_at: string;
        },
      ]
    | null;
  prohabition_request_document_details?: {
    file_name: string;
    url: string;
    uploaded_at: string;
  } | null;
  prohibition_request_documents?: File[];
  prohabition_request_summary?: string | null;
  prohabition_request_date?: string | null;
  prohabition_request_registration_number?: string | null;
  prohabiton_request_date?: string | null;
  prohabition_court_name?: string | null;
  prohabition_court_level?: string | null;
  prohabition_court_region?: string | null;
  prohabition_court_zone?: string | null;
  prohabition_court_woreda?: string | null;
  prohabition_request_first_hearing_date?: string | null;
  prohabition_request_court_registration_number?: string | null;
  asset_recovery_request_date?: string | null;
  prosecutor_decision_on_asset_recovery?: string | null;
  asset_reovery_charge?: string | null;
  asset_recovery_request_documents: File[];
  asset_recovery_request_registration_number?: string;
  asset_recovery_court_name?: string | null;
  asset_recovery_court_level?: string | null;
  asset_recovery_court_region?: string | null;
  asset_recovery_court_zone?: string | null;
  asset_recovery_court_woreda?: string | null;
  asset_recovery_first_hearing_date?: string | null;
  asset_recovery_request_court_registration_number?: string | null;
  asset_recovery_request_date_registrar?: string | null;
  prohabiton_request_date_registrar?: string | null;
  termination_reason?: string | null;
  termination_date?: string | null;
  termination_order_documents?: File[] | null;
  suspension_request_summary?: string | null;
  suspension_reseaon_type?: string | null;
  suspension_request_date?: string | null;
  suspension_request_documents?: File[];
  reinitiate_request_summary?: string | null;
  reinitiate_request_date?: string | null;
  reinitiate_reseaon_type?: string | null;
  reinitiate_request_documents?: File[];
  prosecutor_decision_documents?: File[];
  prosecutor_decision_choice?: string | null;
  prosecutor_decsion_summary?: string | null;
  prosecutor_decision_not_to_prosecute_documents?: File[] | null;
  asset_suspects_ids?: string[] | null;
  assets_ids?: string[] | null;
  suspect_count?: number | null;
  is_the_investigation_finished?: boolean | null;
  suspect_asset_counts?: any[];
  prohibition_record?: ProhibitionRequest[];
  application_type?: string | null;
  administrative_decision_date?: string | null;
  administrative_decision_summary?: string | null;
  administrative_decision_documents?: File[] | null;
}
export interface ProhibitionRequest {
  id: string;
  count_suspect_asset: string[];
  prohabition_request_summary: string;
  status: string;
  forward_status: string;
  prohabition_request_registration_number: string;
  prohabiton_request_date_registrar: string | null;
  prohabition_court_name: string;
  prohabition_court_level: string;
  prohabition_court_region: string;
  prohabition_court_zone: string;
  prohabition_court_woreda: string;
  prohabition_request_first_hearing_date: string | null;
  prohabition_request_court_registration_number: string;
  cordinator_id: string;
  prosecutor_id: string;
  created_at: string;
  updated_at: string;
  referral: string | null;
  prohabition_request_date?: string | null;
  prohabition_request_document?: File[] | null;
  prohibition_request_documents?: File[] | null;
}

export enum APPLICATION_TYPE_CHOICES {
  administrative = "Administrative Actions",
  conventional = "Conventional Base Asset Recovery",
  non_conventional = "Non-Conventional Asset Recovery",
}
export type Report = {
  id: string;
  assets: Asset[];
  court_decision_documents: File[] | null;
  daily_report_summary_documents: File[] | null;
  court_hearing_date: string;
  daily_report_summary: string;
  daily_report_summary_file: string;
  court_order_for_next_appointment: string;
  next_appointment_reasons: string;
  next_appointment_date: string;
  is_next_apointment_reseaon_final_verdict: boolean;
  court_decision_file: string | null;
  court_decision_summary: string | null;
  prosecutor_feedback_on_prohabition_decision: string | null;
  court_decision_date: string | null;
  is_appealed: boolean;
  referral: string;
  asset_details?: Asset[];
  is_next_appointment_reason_final_verdict?: boolean;
  daily_report_documents?: File[];
  asset?: Asset;
  prohabition_request: string;
};
export interface SeizureRestraintFormData {
  seizure_type: "SEIZURE" | "RESTRAIN" | null;
  supervising_authority: string;
  supervising_name: string;
  supervision_notes: string;
  status:
    | "PENDING"
    | "UNDER_SUPERVISION"
    | "RELEASED"
    | "CONFISCATED"
    | "TRANSFERRED"
    | "CANCELLED"
    | null;
  release_date: string | null;
  release_reason: string;
  asset: string | null; // Asset ID
}
export interface Asset {
  id?: string;
  asset_unique_id: string;
  prohabition_court_verdict?: string;
  owner: string;
  asset_owner: string[];
  asset_owner_details?: AssetOwner[];
  owner_relationship_with_suspect: string;
  spouse: string;
  asset_location_region: string;
  asset_location_zone: string;
  asset_location_woreda: string;
  asset_location_town: string;
  asset_category: string;
  asset_number: string;
  estimation_of_money: string;
  quantity: string;
  asset_owned_date: string;
  asset_condition: string;
  crime_category: string;
  crime_location: string;
  how_asset_acquired: string;
  case_condition: string;
  court_verdict_decision_type: string;
  has_asset_recovery_decision: boolean;
  is_owner_above_18: boolean;
  is_the_suspect_the_owner: boolean;
  created_at?: string;
  updated_at?: string;
  referral?: string;
  crime_reference?: string;
  crime_category_others?: string;
  crime_location_zone?: string;
  crime_location_region?: string;
  crime_location_woreda?: string;
  crime_location_town?: string;
  crime_special_place?: string;
  crime_house_number?: string;
  court_name?: string;
  court_registration_number?: string;
  date_of_prohibition?: string;
  prohibition_delivery_evidence?: string;
  prohibition_removal_order?: string;
  court_name_for_removal?: string;
  court_level_for_removal?: string;
  court_region_for_removal?: string;
  court_zone_for_removal?: string;
  court_woreda_for_removal?: string;
  date_of_prohibition_removal?: string;
  prohibition_removal_reason?: string;
  reason_for_not_prohibition?: string;
  prosecutor_decision_type?: string;
  governing_body?: string | null;
  governing_body_contact?: string | null;
  governing_body_region?: string | null;
  governing_body_zone?: string | null;
  governing_body_woreda?: string | null;
  governing_body_house_number?: string | null;
  governing_body_town?: string | null;
  reason_for_governing?: string | null;
  authorizing_body?: string | null;
  governing_duration_start_date?: string | null;
  governing_duration_end_date?: string | null;
  agrement_documents?: File[];
  seizure_restrain_records?: SeizureRestraintRecord[];
  execution_body?: string | null;
  execution_body_contact?: string | null;
  execution_body_region?: string | null;
  execution_body_zone?: string | null;
  execution_body_woreda?: string | null;
  execution_body_house_number?: string | null;
  execution_body_town?: string | null;
  court_nmae?: string | null;
  date_of_prohabition?: string | null;
  prohabition_removal_reason?: string | null;
  Court_name_for_removal?: string | null;
  date_of_prohabition_removal?: string | null;
  is_prohabition_request_decision_appealed?: boolean | null;
  aseet_recovery_court_decson_sumamry?: string | null;
  asset_recovery_court_court_decsion?: string | null;
  is_asset_recovery_decision_appealed?: boolean | null;
}
export interface SeizureRestraintRecord {
  id: string;
  seizure_type: "SEIZURE" | "RESTRAIN";
  supervising_authority: string;
  supervising_name: string;
  supervision_notes: string;
  status:
    | "PENDING"
    | "UNDER_SUPERVISION"
    | "RELEASED"
    | "CONFISCATED"
    | "TRANSFERRED"
    | "CANCELLED";
  release_date: string | null;
  release_reason: string;
  asset: string; // Asset ID
}
export interface Owner {
  id: string;
  person: Person;
  ownership_proof_details?: [
    {
      file_name: string | null;
      url: string | null;
      uploaded_at: string | null;
    },
  ];
  property_description: string;
  ownership_proof: string;
  referral: string;
}

export interface AssetVictim {
  id?: string;

  person: Person | null;
  person_id: string;
  victim_type: string;
  victim_department: string;
  victim_name: string;
  victim_condition: string;
  referral: string;
}
export type AssetOwner = {
  id: string;
  person: Person;
  ownership_proof_details: null;
  property_description: string;
  ownership_proof: null;
  referral: string;
};
export interface Person {
  id?: string;
  id_file_details?: string;
  full_name: string;
  id_number: string;
  id_file: File | null;
  gender: string; // Assuming M/F for gender
  age: string;
  phone: string;
  email: string;
  region: string;
  zone: string;
  subcity: string;
  woreda: string;
  town: string;
  house_number: string;
  fayda_number: string;
  created_at?: string;
  updated_at?: string;
}
export interface AssetSuspect {
  id?: string;
  person?: Person | null;
  person_id?: string;
  court_bail_evidence_details: [{ file_name: string; url: string }];
  police_bail_evidence_details: [{ file_name: string; url: string }];
  suspect_condition?: string; // nullable: true
  court_appointment_date: string;
  final_verdict_amount: string;
  not_in_custody_reason: string;
  bail_information?: string; // nullable: true
  court_registration_number: string;
  court_bail_amount: string;
  court_bail_evidence: File | null;
  incident_registration_number: string;
  crime_registration_number: string;
  police_bail_amount: string;
  police_bail_evidence: File | null;
  referral: string;
}

export interface FileDetails {
  file_name: string;
  url: string;
  uploaded_at: string | null;
}

export interface ReferralEvidence {
  id: string;
  file_details: FileDetails;
  evidence_type: string;
  file: string;
  description: string;
  date: string;
  referral: string;
  evidence_file_details?: [{ file_name: string; url: string }];
}
export type TreeSelectOption = {
  label: string;
  value: string;
  children?: TreeSelectOption[];
};
export interface OrgUnit {
  uu_id: string;
  hierarchy_level: HierarchyLevel;
  unit_name: string;
  structure_level: string;
  description: string;
  is_vacant: boolean;
  is_open: boolean;
  parent_unit: string;
  children?: OrgUnit[];
}
export type AssetProsecutor = {
  role: any;
  user: User;
};

interface User {
  id: string;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  employee_id: string;
  employee_administration_unit: string;
  employee_organizational_unit: string;
  is_active: boolean;
  is_superuser: boolean;
  password_changed: boolean;
}
export interface IncidentByMobile {
  id: number;
  uploaded_files: DocumentSchema[];
  complainant_name?: string;
  complainant_phone?: string;
  complainant_email?: string;
  incident_against?: string;
  incident_against_geneder?: string;
  date_of_offense?: Date;
  offence_description?: string;
  region?: string;
  city_zone?: string;
  kebele_woreda?: string;
  status?: string;
  report_application_number?: string;
  created_at?: Date;
  updated_at?: Date;
}

export interface PrivateProsecution {
  id?: number;
  forwarding_status?: keyof typeof PrivateProsecutionForwardingStatus | null;
  status?: keyof typeof PrivateProsecutionStatus;
  applicant_name?: string;
  applicant_contact?: string;
  applicant_region?: string;
  applicant_city?: string;
  applicant_sub_city?: string;
  applicant_woreda?: string;
  applicant_kebele?: string;
  applicant_house_number?: string;
  applicant_phone_number?: string;
  applicant_email?: string;
  reason_for_private_prosecution?: string;
  registaration_number?: string;
  registration_date?: Date;
  investigation_file: number | null;
  documents?: DocumentSchema[];
  feedbacks?: PrivateProsecutionFeedback[];
  private_prosecution_decision?: File;
  private_prosecution_decision_file?: File;

  reports?: PrivateProsecutionReport[];
}
export const PrivateProsecutionForwardingStatus = {
  forward_to_coordinator: "Forward to Coordinator",
  on_prosecutor_desk: "On Prosecutor Desk",
  forward_to_registrar: "Forward to Registrar",
  forwarded_to_indvdual: "Forwarded to Individual",
};
export const PrivateProsecutionStatus = {
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
  withdrawn: "Withdrawn",
  on_litigation: "On Litigation",
  final_verdict_given: "Final Verdict Given",
  on_appeal: "On Appeal",
};

export interface PrivateProsecutionReport {
  id?: number;
  private_prosecution_report_summary?: string;
  created_by?: string;
  private_prosecution?: number;
  report_file?: File | null;
  documents?: DocumentSchema[];
}
export interface PrivateProsecutionFeedback {
  id?: number;
  feedback_text?: string;
  created_by?: string;
  private_prosecution?: number | null;
}
export interface PrivateProsecutionReportDocument {
  id?: number;
  document_type?: string;
  document_uuid?: string | null;
  document_path?: string;
  created_at?: Date | null;
  updated_at?: Date | null;
  private_prosecution?: number | null;
}
